import P2Regular from 'components/typography/P2Regular';
import { MeasuringDeviceRow } from 'components/tables/data/measuring-device/types';
import Excerpt from 'components/Excerpt';

/**
 * Column for the description.
 */
export default function DescriptionColumn({ data: { description = '' } }: { data: MeasuringDeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      <Excerpt text={description} length={30} />
    </P2Regular>
  );
}
